import {all,put} from 'redux-saga/effects';
import asyncWatcher from './async';
import contentfulWatcher from "./contentful";

export default function* rootSaga() {
  try {
    yield all([
      contentfulWatcher(),
      asyncWatcher()
    ]);
  } catch (error) {
    console.log(error);
    yield put({type:"ASN_FAILED", value:error})
  }
}

